import ProfileType from "../types/profileType";

interface profileAction {
  type: string;
  payload?: any;
  dashboardData: any;
}

const initial_state = {
  dashboardData: {
    totalJoining: 0,
    newJoining: 0,
    poGenerate: 0,
    myOrders: 0,
    pendingOrders: 0,
    placedOrders: 0,
    dispatchOrders: 0,
    shippedOrders: 0,
    deliveredOrders: 0,
    cancelledOrders: 0,
    totalProducts: 0,
    activatedProducts: 0,
    deActivatedProducts: 0,
    eComProducts: 0,
    buyerAcceptancePending: 0,
    sellerAcceptancePending: 0,
    buyerPaymentPending: 0,
    sellerPaymentPending: 0,
    buyerVerificationPending: 0,
    sellerVerificationPending: 0,
    buyerDispatchedPending: 0,
    sellerDispatchedPending: 0,
    buyerReceivedPending: 0,
    sellerReceivedPending: 0,
    buyerDeliveredPending: 0,
    sellerDeliveredPending: 0,
    buyerCancelledPending: 0,
    sellerCancelledPending: 0,
    todayPurchaseAmount: 0,
    totalPurchaseAmount: 0,
    todaySaleAmount: 0,
    totalSaleAmount: 0,
    totalOrder: 0,
    totalPv: 0,
  },
  buyerNotifications: [],
  sellerNotifications: [],
  currentPage: 0,
  lastPage: 0,
  totalData: 0,
  from: 0,
  to: 0,
  stateList: [],
  cityList: [],
  allCityList: [],
  ermData: [],
  latestMessage: [],
};

const CategoryReducer = (state = initial_state, action: profileAction) => {
  switch (action.type) {
    case ProfileType.UPDATE_KYC_DOCUMENTS:
      return {
        ...state,
      };

    case ProfileType.DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: {
          totalJoining: action.payload.totalJoining,
          newJoining: action.payload.newJoining,
          poGenerate: action.payload.poGenerate,
          myOrders: action.payload.myOrders,
          pendingOrders: action.payload.pendingOrders,
          placedOrders: action.payload.placedOrders,
          dispatchOrders: action.payload.dispatchOrders,
          shippedOrders: action.payload.shippedOrders,
          deliveredOrders: action.payload.deliveredOrders,
          cancelledOrders:
            action.payload.cancelledOrders +
            action.payload.cancelledByUserOrders,
          totalProducts: action.payload.totalProducts,
          activatedProducts: action.payload.activatedProducts,
          deActivatedProducts: action.payload.deActivatedProducts,
          eComProducts: action.payload.eComProducts,
          buyerAcceptancePending: action.payload.buyerAcceptancePending,
          sellerAcceptancePending: action.payload.sellerAcceptancePending,
          buyerPaymentPending: action.payload.buyerPaymentPending,
          sellerPaymentPending: action.payload.sellerPaymentPending,
          buyerVerificationPending: action.payload.buyerVerificationPending,
          sellerVerificationPending: action.payload.sellerVerificationPending,
          buyerDispatchedPending: action.payload.buyerDispatchedPending,
          sellerDispatchedPending: action.payload.sellerDispatchedPending,
          buyerReceivedPending: action.payload.buyerReceivedPending,
          sellerReceivedPending: action.payload.sellerReceivedPending,
          buyerDeliveredPending: action.payload.buyerDeliveredPending,
          sellerDeliveredPending: action.payload.sellerDeliveredPending,
          buyerCancelledPending: action.payload.buyerCancelledPending,
          sellerCancelledPending: action.payload.sellerCancelledPending,
          todayPurchaseAmount: action.payload.todayPurchaseAmount,
          totalPurchaseAmount: action.payload.totalPurchaseAmount,
          todaySaleAmount: action.payload.todaySaleAmount,
          totalSaleAmount: action.payload.totalSaleAmount,
          totalOrder: action.payload.totalOrder,
          totalPv: action.payload.totalPv,
        },
      };

    case ProfileType.SET_NOTIFICATIONS:
      if (action.payload.type === "SELLER") {
        return {
          ...state,
          sellerNotifications: action.payload.data,
          currentPage: action.payload.currentPage,
          lastPage: action.payload.lastPage,
          totalData: action.payload.totalData,
          from: action.payload.from,
          to: action.payload.to,
        };
      } else {
        return {
          ...state,
          buyerNotifications: action.payload.data,
          currentPage: action.payload.currentPage,
          lastPage: action.payload.lastPage,
          totalData: action.payload.totalData,
          from: action.payload.from,
          to: action.payload.to,
        };
      }

    case ProfileType.SET_STATE_DATA:
      return {
        ...state,
        stateList: action.payload,
      };

    case ProfileType.SET_CITY_LIST:
      return {
        ...state,
        cityList: action.payload,
      };

    case ProfileType.SET_ALL_CITY_LIST:
      return {
        ...state,
        allCityList: action.payload,
      };

    case ProfileType.SET_ERM_DETAILS:
      return {
        ...state,
        ermData: action.payload,
      };

    case ProfileType.GET_LATEST_MESSAGE:
      return {
        ...state,
        latestMessage: action.payload,
      };

    default:
      return state;
  }
};

export default CategoryReducer;
